import { Checkbox, IconButton, makeStyles, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  cellRoot: {
    overflow: 'visible',
    textAlign: 'center',
    paddingLeft: '8px',
    paddingRight: '0px',
  },
  SimpleTableCheckboxRoot: {
    padding: 0,
  },
});

function TableSelectionHeaderCell(props) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const { loading, totalCount, selectionType, selection, onSelectionTypeChange } = props;

  useEffect(() => {
    if (!loading && totalCount > 0) {
      if (selectionType === 'TODOS_PAGINA' && selection.length === 0) {
        onSelectionTypeChange('NENHUM');
      }
      if (selectionType === 'TODOS_FILTRO' && selection.length === totalCount) {
        onSelectionTypeChange('NENHUM');
      }
    }
    // Reage apenas à mudança da seleção, como no comportamento original.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection]);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxClick = (e) => {
    handleMenuClick(e, 'TODOS_PAGINA');
  };

  const handleMenuClick = (e, item) => {
    e.stopPropagation();
    e.preventDefault();

    switch (item) {
      case 'TODOS_FILTRO':
        props.onSelectionTypeChange('TODOS_FILTRO');
        props.onSelectionChange([]);

        break;
      case 'TODOS_PAGINA':
        if (props.selectionType === 'TODOS_FILTRO' && props.totalCount <= props.pageSize) {
          props.onSelectionTypeChange('NENHUM');
          props.onSelectionChange([]);

          break;
        }

        // props.onToggle();

        if (
          props.rows.some((linha) => {
            return props.selection.find((selecionado) => selecionado.id === linha.id);
          })
        ) {
          const selecionados = props.selection.filter((s) => props.rows.includes((r) => r.id === s.id));
          if (selecionados.length === 0) {
            props.onSelectionTypeChange('NENHUM');
          } else {
            props.onSelectionTypeChange('TODOS_PAGINA');
          }
          props.onSelectionChange(selecionados);
        } else {
          props.onSelectionTypeChange('TODOS_PAGINA');
          props.onSelectionChange(props.selection.concat(props.rows));
        }

        break;
      case 'NENHUM':
      default:
        props.onSelectionTypeChange('NENHUM');
        props.onSelectionChange([]);
        break;
    }
  };

  const isChecked = (props) => {
    if (props.selectionType === 'NENHUM' || props.selectionType === 'TODOS_PAGINA') {
      return props.selection.length === props.totalCount;
    }
    if (props.selectionType === 'TODOS_FILTRO') {
      return props.selection.length === 0;
    }
  };

  const isIndeterminate = (props) => {
    if (props.selectionType === 'NENHUM' || props.selectionType === 'TODOS_PAGINA') {
      return props.selection.length !== 0 && props.selection.length !== props.totalCount;
    }
    if (props.selectionType === 'TODOS_FILTRO') {
      return props.selection.length !== 0 && props.selection.length !== props.totalCount;
    }
  };

  return (
    <th
      className={clsx('MuiTableCell-root MuiTableCell-head MuiTableCell-paddingCheckbox h-64', classes.cellRoot)}
      scope="col"
      colSpan={props.colSpan}
    >
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <TableSelectionHeaderCellMenu anchorEl={anchorEl} onClose={handleClose} onSelectItem={handleMenuClick} />
        <Checkbox
          classes={{ root: classes.SimpleTableCheckboxRoot }}
          disabled={props.disabled}
          color="primary"
          checked={isChecked(props)}
          indeterminate={isIndeterminate(props)}
          onClick={handleCheckboxClick}
        />
        <div className="stepCaixaSelecao">
          <IconButton disabled={props.disabled} onClick={handleOpen} style={{ margin: 0, padding: 0 }}>
            <ArrowDropDownIcon />
          </IconButton>
        </div>
      </span>
    </th>
  );
}

function TableSelectionHeaderCellMenu({ anchorEl, onClose, onSelectItem }) {
  const handleMenuItemClick = (event, item) => {
    onSelectItem(event, item);
    onClose(null);
  };

  return (
    <div>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClick={() => onClose(null)}>
        <MenuItem onClick={(event) => handleMenuItemClick(event, 'TODOS_FILTRO')}>Todos do filtro</MenuItem>
        <MenuItem onClick={(event) => handleMenuItemClick(event, 'TODOS_PAGINA')}>Todos da página</MenuItem>
        <MenuItem onClick={(event) => handleMenuItemClick(event, 'NENHUM')}>Nenhum</MenuItem>
      </Menu>
    </div>
  );
}

export default TableSelectionHeaderCell;
